/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { IPatientIdentifierType } from 'app/shared/model/patient-identifier-type.model';

export interface IPatientIdentifier {
  id?: string;
  identifier?: string | null;
  provider?: string | null;
  preferred?: boolean | null;
  microSec?: number | null;
  timestampentry?: number | null;
  lastupdated?: number | null;
  cursor?: number | null;
  active?: boolean | null;
  verified?: boolean | null;
  patient?: IGlucoUser;
  identifierType?: IPatientIdentifierType;
}

export const defaultValue: Readonly<IPatientIdentifier> = {
  preferred: false,
  active: false,
  verified: false,
};
